import React, { useState } from 'react';
import css from './FilterSidebar.module.css';
import { divisionSchoolOptions } from '../../../config/configExtras';
import FilterSectionHeader from './FilterSectionHeader';
import SearchInput from './SearchInput';
import classNames from 'classnames';

const SchoolFilterSection = ({
  handleClearFilter,
  handleCheckboxChange,
  selectedValues,
  paramKey,
  isBlackBgFilter,
  isTalentOfferingFilters,
}) => {
  // Local search state
  const [searchTerm, setSearchTerm] = useState('');

  // Filter the schools by the user's search
  const filteredSchools = divisionSchoolOptions.filter(s =>
    s.school.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Show only the first 10 results
  const displayedSchools = filteredSchools.slice(0, 10);
  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };
  return (
    <div
      className={classNames(
        css.filterSection,
        isTalentOfferingFilters ? css.talentOfferingFilters : null
      )}
    >
      {!isTalentOfferingFilters && (
        <FilterSectionHeader
          isBlackBgFilter={isBlackBgFilter}
          titleId={'FilterCategories.school'}
          handleClear={handleClear}
        />
      )}
      {/* Search Input */}
      <SearchInput
        placeholder="Search School..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />

      {searchTerm && (
        <div className={css.scrollable}>
          {/* Each school is a checkbox */}
          {displayedSchools.map((s, index) => {
            const optionKey = s.school;
            const isChecked = selectedValues.includes(optionKey);
            return (
              <label key={`${s.school}-${index}`} className={css.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  value={optionKey}
                  onChange={e => handleCheckboxChange(e, paramKey)}
                  name="school"
                />
                <span>{s.school}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SchoolFilterSection;
